const translations = {
    acresTreated: 'Acres treated',
    aerialApplication: 'Aerial Application',
    airTemperature: 'Air temperature',
    applicationMethod: 'Application method',
    drone: 'Drone',
    equipment: 'Equipment',
    fahrenheit: '{{value}} \u00b0F',
    hectares: '{{value}} ha',
    milesPerHour: '{{value}} MPH',
    percent: '{{value}}%',
    proposedAcres: 'Proposed acres',
    relativeHumidity: 'Relative humidity',
    siteCommodity: 'Site commodity',
    squareMeters: '{{value}} m\u00b2',
    targetSprayRate: 'Target spray rate (total output)',
    title: 'Site Commodity',
    weatherAtApplication: 'Weather at application',
    windDirection: 'Wind direction',
    windGust: 'Wind gust',
    windSpeed: 'Wind speed'
};

export default translations;
